import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { swiperConfig } from '@/helpers/utils/swiperConfig';
import { ProductItem } from './productItem';

const AlgoliaRecommendProductsList = (products: any) => {
  const slidesPerGroup = 4;

  const blankSlidesCount =
    products?.item?.length % slidesPerGroup === 0 ? 0 : slidesPerGroup - (products?.item?.length % slidesPerGroup);
  return (
    <Swiper {...swiperConfig} className="mySwiper multiSlide">
      {products?.item?.map((product: any) => {
        return (
          <SwiperSlide key={product.objectID}>
            <ProductItem hit={product} crossSell={product.crossSell} />
          </SwiperSlide>
        );
      })}
      {Array.from({ length: blankSlidesCount }).map((_, index) => (
        <SwiperSlide key={`blank-slide-${index}`}>
          <div className="h-full min-h-[1px]" />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default AlgoliaRecommendProductsList;
